import styled from 'styled-components';

import { Shimmer as ShimmerEffect } from 'ggApp/shared/components/shimmerEffect/styles';

export const Container = styled.section`
    display: flex;
    flex-direction: column;
`;

export const CardGrid = styled.div`
    margin-top: 16px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-gap: 16px;
    ${({ theme }) => theme && theme.superQuery.all.and.maxWidth.mobileMax.css`
        grid-template-columns: 1fr 1fr;
        grid-gap: 8px;
    `}
`;

export const Title = styled.label`
    ${({ theme }) => theme.typography.Subheadline};
`;

export const Card = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 16px;
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    border-radius: 8px;
    min-height: 180px;
    ${({ theme }) => theme && theme.superQuery.all.and.maxWidth.mobileMax.css`
        min-height: 160px;
    `}
`;

export const Label = styled.h4`
    height: 40px;
    margin-top: 16px;
    text-align: center;
    display: flex;
    align-items: flex-end;
    ${({ theme }) => theme.typography.SmallHeadline};
    ${({ theme }) => theme && theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin-top: 12px;
        max-height: 40px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    `}
`;

export const Image = styled.img`
    width: auto;
    max-height: 90px;
    max-width: 90px;
    filter: ${({ isDarkMode }) => isDarkMode && 'invert(1)'};
`;

export const Shimmer = styled(ShimmerEffect)`
    left: 0;
    z-index: 1;
`;
